export default __webpack_public_path__ + "static/media/completed.a60df425.png";